export const OutgoingBeneficiaryTypeNames = {
    Normal  : 0,
    Customer: 1,
    TBA     : 2,
}
